import React, { useCallback } from 'react';
import { Card, CardBody } from 'reactstrap';
import { useNotify } from 'js/hooks/useNotify';
import formatRubricSaveError from './formatRubricSaveError';
import RubricForm from './RubricForm';
import InheritedBreakouts from './InheritedBreakouts';

function RubricSettingsComponent({
  workspaceId,
  rubric,
  onSave,
  breakouts = [],
  breakoutsLoading = false,
  excludedBreakoutIds = [],
  onExcludedBreakoutsChange,
}) {
  const notify = useNotify();

  const handleSubmit = useCallback(
    async (values) => {
      try {
        await onSave({
          name: values.name.trim(),
        });
        notify({
          type: 'success',
          message: 'Rubric settings saved.',
        });
      } catch (err) {
        notify({
          type: 'danger',
          message: formatRubricSaveError(err),
        });
      }
    },
    [notify, onSave]
  );

  return (
    <>
      <Card className="mb-3">
        <CardBody>
          <RubricForm
            submitLabel="Update"
            rubric={rubric}
            onSubmit={handleSubmit}
            cancelUrl={`/w/${workspaceId}/rubrics/${encodeURIComponent(
              rubric.id
            )}`}
          />
        </CardBody>
      </Card>
      <InheritedBreakouts
        document={rubric.document}
        breakouts={breakouts}
        loading={breakoutsLoading}
        excludedBreakoutIds={excludedBreakoutIds}
        onChange={onExcludedBreakoutsChange}
      />
    </>
  );
}

export default RubricSettingsComponent;
